/** Bounded read refresh, only while visible and online. No retries of writes. */
export function foregroundRefresh(refresh: () => void | Promise<void>, enabled: () => boolean = () => true, intervalMs = 15000): () => void {
  let stopped = false;
  let pending = false;
  let last = 0;
  const interval = Math.max(3000, intervalMs);
  async function tick(): Promise<void> {
    if (stopped || pending || document.visibilityState === 'hidden' || navigator.onLine === false || !enabled() || Date.now() - last < 2000) return;
    pending = true; last = Date.now();
    try { await refresh(); } catch { /* The owning view displays recoverable read errors. */ }
    finally { pending = false; }
  }
  const onResume = () => { void tick(); };
  const timer = setInterval(onResume, interval);
  window.addEventListener('focus', onResume);
  window.addEventListener('online', onResume);
  document.addEventListener('visibilitychange', onResume);
  return () => {
    stopped = true; clearInterval(timer);
    window.removeEventListener('focus', onResume);
    window.removeEventListener('online', onResume);
    document.removeEventListener('visibilitychange', onResume);
  };
}
